
































import Vue from 'vue';
import ATransitionExpand from '@/components/ATransitionExpand.vue';
import ChevronDownIcon from '@/assets/chevron-down.svg';

interface Data {
  contentVisible: boolean;
}

export default Vue.extend({
  name: 'AExpansionPanel',
  components: {
    ATransitionExpand,
    ChevronDownIcon,
  },
  props: {
    initiallyExpanded: Boolean,
    headerBlock: Boolean,
  },
  data(): Data {
    return {
      contentVisible: this.initiallyExpanded,
    };
  },
  methods: {
    toggleContentVisible(): void {
      this.contentVisible = !this.contentVisible;
    },
  },
});
